// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"3a62f67b","704":"9093a87f","743":"22e483a7","772":"96f245b7","846":"ec464be3","930":"9093a87f"}[chunkId] + ".chunk.css";
};